import { useMutationBuilder, useQueryBuilder } from "src/query/useBuilders";
import { ACCOUNT, FETCH, UPDATE } from "../queryKeys";
import { accountsApi } from "src/services/settings/accountManagement";
import { Account, UpdateAccountRequest } from "src/types/accounts";

export const useAccountQuery = () => {
  return useQueryBuilder([ACCOUNT, FETCH], async () => {
    const data = await accountsApi.fetchAccount();
    return data as Account[];
  });
};

export const useAccountUpdate = () => {
  return useMutationBuilder<Account, UpdateAccountRequest>(
    [ACCOUNT, UPDATE],
    (data) => accountsApi.updateAccount(data),
    [ACCOUNT, FETCH]
  );
};
